console.log('Custom JS loaded');
// Footer js //
  (() => {
    document.querySelectorAll('.footer-summary').forEach(summary => summary.addEventListener('click', toggleFooterDetails))
  })()

  function toggleFooterDetails(e) {
    const elementSelector = e.target.dataset.target;
    if(!e.target.dataset.target) return;
    const target = document.querySelector(elementSelector);
    e.target.classList.toggle('open');
    target.classList.toggle('open');
  }

// Filter values //
  class FilterValue extends HTMLElement {
    connectedCallback() {
      const name = this.getAttribute('data-name');
      const value = this.getAttribute('data-value');
      this.innerHTML = this.innerHTML || '&times;';
      this.style.cursor = 'pointer';
      this.addEventListener('click', () => {
        const targetElement = document.querySelector(`[name="${name}"][value="${value}"]`);
        if (targetElement) {
          targetElement.click();
        } else {
          console.log(`Element with name="${name}" and value="${value}" not found.`);
        }
      });
    }
  }
  customElements.define('filter-value', FilterValue);

  // Fabric Group //
  function handleLinkedProductClick(event) {
    const currentElement = event.target;
    const linkedItem = currentElement.closest('linked-product');
    const fabricWrap = currentElement.closest('.pdp-main__fabric');
    const allColourWraps = document.querySelectorAll('.pdp-main__colour');
    const fabric = linkedItem.getAttribute('replace-to');
    const replaceFrom = linkedItem.getAttribute('replace-form');
    const colourWrap = document.querySelector(`.pdp-main__colour[data-fabric="${fabric}"]`);
    const form = currentElement.closest('.pdp-main__form');
    
    if (!form || !linkedItem || !fabricWrap || linkedItem.querySelector('a')) return;
    form.classList.add('all-unavailable');
    const titles = document.querySelectorAll('.pdp-main__title, .c-breadcrumbs__link--product');
    titles.forEach(title => {
    title.textContent = title.textContent.replace(replaceFrom, fabric);
    });

    const activeItem = fabricWrap.querySelector('.is-active');
    if (!activeItem) return;

    activeItem.classList.remove('is-active');
    linkedItem.classList.add('is-active');

    if (colourWrap) {
    allColourWraps.forEach((colourWrap) => colourWrap.classList.add('hidden'));
    colourWrap.classList.remove('hidden');
    document
        .querySelectorAll('.pdp-main__colour-radio-wrapper')
        .forEach((radioWraper) => radioWraper.classList.remove('is-active'));
    document
        .querySelectorAll('.c-color-status')
        .forEach((icon) => icon.classList.remove('c-color-select__icon-active'));
    document.querySelector('.js-product-add-to-cart').classList.add('hidden');
    }
  }

  window.onload = () => {
    document.querySelectorAll('linked-product').forEach((linkedProductElement) => {
    linkedProductElement.setExternalClickHandler(handleLinkedProductClick);
    });
  };

  // Main Cart Footer //
  document.addEventListener('DOMContentLoaded', function () {
    function isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        const trident = ua.indexOf('Trident/');

        return (msie > 0 || trident > 0);
    }

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function (event) {
        document.querySelector('#cart').submit();
    });
  });

  // Product Recommendations //

    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('.quantity-decrement').forEach(function(btn) {
            btn.addEventListener('click', function() {
                const input = btn.parentNode.querySelector('input[type=number]');
                if (input) input.stepDown();
            });
        });
    });
    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('.quantity-increment').forEach(function(btn) {
            btn.addEventListener('click', function() {
                const input = btn.parentNode.querySelector('input[type=number]');
                if (input) input.stepUp();
            });
        });
    });

    // Fabric Guide //
    document.addEventListener('DOMContentLoaded', function() {
      var btn = document.getElementById('fabric-guide-btn');
      var modal = btn && btn.nextElementSibling;
      if (btn && modal && typeof modal.open === 'function') {
        btn.addEventListener('click', function() {
            modal.open();
        });
      }
    });